import React, { useState } from 'react';
import Drawer from '../Common/Drawer/Drawer';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import Notification from '../Common/Notification';
import { useUpdateStatus } from '../../apis/locationTasks';
import type { StatusFilterOption } from '../../apis/locationTasks/locationTask.types';

interface BulkUpdateStatusDrawerProps {
    onComplete: () => void;
    onCancel: () => void;
    statuses: StatusFilterOption[];
    locationTasks: Array<{ id: number }>;
}

export const BulkUpdateStatusDrawer = ({ onComplete, onCancel, statuses, locationTasks }: BulkUpdateStatusDrawerProps) => {
    const [selectedStatusId, setSelectedStatusId] = useState<number | ''>('');
    const [isFormValid, setIsFormValid] = useState(true);

    const { mutate: updateStatus, isPending } = useUpdateStatus(() => {
        Notification('success', 'Status Updated', 'New Status has been set');
        onComplete();
    });

    const onSave = () => {
        if (!selectedStatusId) {
            setIsFormValid(false);
            return;
        }
        if (isPending) return;
        updateStatus(
            { locationTaskIds: locationTasks.map((t) => t.id), statusId: Number(selectedStatusId) },
            { onError: (err) => Notification('error', 'Error', err.message) }
        );
    };

    return (
        <Drawer isOpen={true} isWide={false} title='Bulk Update Status'
            onSaveClick={onSave}
            saveText={isPending ? 'Saving...' : 'Save'}
            onCancelClick={onCancel}>

            <form noValidate className={isFormValid ? '' : 'was-validated'}>
                <MultiSelectBox
                    name='status'
                    label='Status'
                    idField='id'
                    valueField='name'
                    selectedValues={selectedStatusId.toString()}
                    options={statuses}
                    isRequired={true}
                    errorMessage='Choose a status'
                    isMulti={false}
                    onChange={(id: number) => setSelectedStatusId(id)}
                />
            </form>

        </Drawer>
    );
};

export default BulkUpdateStatusDrawer;
